import { render, staticRenderFns } from "./crudZones.vue?vue&type=template&id=c79dcd3e&"
import script from "./crudZones.vue?vue&type=script&lang=js&"
export * from "./crudZones.vue?vue&type=script&lang=js&"
import style0 from "./crudZones.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports